import { gql } from '@apollo/client'

export const DELETE_CITY = gql`
  mutation deleteCity($input: ID!) {
    data: deleteCity(id: $input) {
      id
    }
  }
`
